import App from './App.vue'
// import { createApp } from 'vue'
import routes from './router/public'
import i18n from "@/lang"
import { ViteSSG } from 'vite-ssg'
// import { setupRouter } from './router'
import { setupStore } from './store'
// import { registerGlobDirective } from './directive'
// import { registerGlobFilter } from './filters'

import './styles/base.scss'
import 'virtual:svg-icons-register'

export const createApp = ViteSSG(
  // the root component
  App,
  // vue-router options
  { routes },
  // function to have custom setups
  ({ app, router, routes, isClient, initialState }) => {
    // install plugins etc.
    // Configure store
    // 配置 store
    app.use(i18n)
    setupStore(app)
  },
)

// const app = createApp(App)

// // Configure routing
// // 配置路由
// setupRouter(app)
//
// // Register global directive
// // 注册全局指令
// // registerGlobDirective(app)
//
// // 注册全局过滤器
// // registerGlobFilter(app)
//
// app.mount('#app')